import { MONITORING_ALERT_TEXT } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.constants';

import Icons from 'assets/icons';

interface MonitoringAlertProps {
  'data-testid': string;
}

const MonitoringAlert = ({
  'data-testid': dataTestId,
}: MonitoringAlertProps) => (
  <div
    className="flex items-center gap-1 text-xs font-medium leading-4 text-amber-700"
    data-testid={dataTestId}
  >
    <Icons.Info className="size-3.5 shrink-0" aria-hidden="true" />
    <span>{MONITORING_ALERT_TEXT}</span>
  </div>
);

export default MonitoringAlert;
